import React, { FC } from "react";
import styles from "./Footer.module.less";
import { LinkButton } from "@digipost/dds-buttons-react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRight } from "@fortawesome/pro-solid-svg-icons/faArrowUpRight";
import Translated from "../infrastructure/translation/Translated";
import { useLanguage } from "@digipost/translate";
import {
  getEnvBaseUrl,
  getTermsUrl,
} from "../infrastructure/translation/translatedUrls";

const Footer: FC = (): React.ReactElement => {
  const { language } = useLanguage();

  return (
    <footer className={styles.footer}>
      <section className={styles.footerInner}>
        <img
          src={"/images/logo/posten-logo-farge.svg"}
          alt=""
          className={styles.logoPosten}
        />
        <div className={styles.textContent}>
          <div className={styles.innerText}>
            <p>
              <Translated textKey={"footer.posten"} />
            </p>
            <LinkButton
              iconLeft={<FontAwesomeIcon icon={faArrowUpRight} />}
              className={styles.link}
              as={"a"}
              href={getTermsUrl(language)}
            >
              <Translated textKey={"footer.privacy"} />
            </LinkButton>
            <LinkButton
              iconLeft={<FontAwesomeIcon icon={faArrowUpRight} />}
              className={styles.link}
              as={"a"}
              href={getEnvBaseUrl() + "/cookies"}
            >
              <Translated textKey={"footer.cookies"} />
            </LinkButton>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
